import Vue from 'vue';

import date from './date';
import localize from './localize';
import join from './join';

function setupVueFilters() {
    Vue.filter('date', date);
    Vue.filter('l', localize);
    Vue.filter('join', join);
}

export {
    setupVueFilters,

    date,
    localize,
    join,
};
